/**
 * created by zhouzt on 2020-05-21
 *
 * description: 已定价接口
 *
 */

const config = require('libs/config.js')

const priced = {
	// 订单列表
	pricedOrderList: (role, status = '') => config.MS_XY_PATH + `/outline/${role}/order/have/${status}`,
	// 已定价订单暂存订单
	pricedTempSave: role => config.MS_XY_PATH + `/outline/${role}/order/saveAsTemp`,
	// 已定价订单保存订单
	pricedSave: role => config.MS_XY_PATH + `/outline/${role}/order/save`,
	// 已定价订单修改订单
	pricedModify: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/order/${pkid}`,
	// 已定价删除订单
	pricedDel: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/order/${pkid}`,
	// 已定价发送订单
	pricedSend: role => config.MS_XY_PATH + `/outline/${role}/order/send`,
	// 已定价确认报价
	pricedConfirmQuote: config.MS_XY_PATH + '/outline/buy/order/confirmQuote',
	// 已定价驳回报价
	pricedRejectQuote: role => config.MS_XY_PATH + `/outline/${role}/order/rejectQuote`,
	// 已定价撤回订单
	pricedRecall: config.MS_XY_PATH + '/outline/buy/order/recall',
	// 已定价作废订单
	pricedCancel: config.MS_XY_PATH + '/outline/buy/order/cancel',
	// 已定价同意订单
	pricedAgree: config.MS_XY_PATH + '/outline/sell/order/agree',
	// 已定价拒绝订单
	pricedRefuse: config.MS_XY_PATH + '/outline/sell/order/refuse',
	// 已定价驳回订单
	pricedReject: role => config.MS_XY_PATH + `/outline/${role}/order/reject`,
	// 已定价提醒对方确认
	pricedRemindCofirm: (role, orderCode) => config.MS_XY_PATH + `/outline/${role}/order/remind/${orderCode}`
}

export default priced



// WEBPACK FOOTER //
// ./src/api/trade/priced.js